var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArianeHero({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1608,
    height: 320,
    viewBox: "0 0 1608 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "y92lrhw2xa",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1608,
    height: 320
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h1608v320H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#y92lrhw2xa)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1608 0H0v320h1608V0z",
    fill: "#B61818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1284.16 77.36c18.89-16.698 30.5-36.52 30.5-36.52l3.17-5.074s12.79-19.17 19.09-42.71c10.66-39.843-22.78-58.523-29.65-61.889-6.52-3.897-40.46-21.788-72.43 6.482-18.89 16.698-30.5 36.52-30.5 36.52l-3.17 5.065s-12.79 19.17-19.09 42.71c-10.66 39.843 22.78 58.523 29.65 61.889 6.52 3.897 40.46 21.788 72.43-6.482",
    fill: "#216AFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1352.16 432.352c18.89-16.697 30.5-36.519 30.5-36.519l3.17-5.073s12.79-19.169 19.09-42.708c10.66-39.84-22.78-58.52-29.65-61.885-6.52-3.897-40.46-21.787-72.43 6.481-18.89 16.706-30.5 36.519-30.5 36.519l-3.17 5.073s-12.79 19.169-19.09 42.708c-10.66 39.84 22.78 58.52 29.65 61.885 6.52 3.897 40.46 21.787 72.43-6.481z",
    fill: "#FBBC33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1504.32 97.393c27.44-24.126 44.31-52.75 44.31-52.75l4.61-7.32s18.6-27.691 27.74-61.686c15.48-57.546-33.1-84.537-43.06-89.394-9.49-5.636-58.8-31.472-105.25 9.364-27.44 24.126-44.3 52.75-44.3 52.75l-4.61 7.32s-18.6 27.691-27.74 61.686c-15.48 57.546 33.1 84.537 43.07 89.394 9.49 5.636 58.79 31.472 105.24-9.364",
    fill: "#D11314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1239.76 411.187c46.93-41.411 75.76-90.543 75.76-90.543l7.89-12.57s31.78-47.53 47.43-105.891c26.47-98.786-56.6-145.108-73.64-153.453-16.22-9.674-100.53-54.017-179.96 16.074-46.93 41.412-75.76 90.544-75.76 90.544l-7.89 12.57s-31.78 47.53-47.427 105.89c-26.468 98.787 56.597 145.108 73.637 153.463 16.22 9.673 100.53 54.016 179.96-16.075",
    fill: "#EB0B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.978 490.859c41.352-36.428 66.742-79.654 66.742-79.654l6.95-11.059s28.01-41.812 41.78-93.157c23.32-86.898-49.86-127.655-64.88-134.994-14.29-8.504-88.561-47.521-158.548 14.138-41.349 36.427-66.744 79.653-66.744 79.653l-6.947 11.06s-28.009 41.811-41.783 93.156c-23.317 86.907 49.866 127.655 64.887 135.003 14.291 8.504 88.565 47.521 158.552-14.138",
    fill: "#D11314"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "2nyh2gim0b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1608,
    height: 320
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h1608v320H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArianeHero);
export default __webpack_public_path__ + "static/media/ariane-hero.c6a5f63b49fe3867c910bb364621a52d.svg";
export { ForwardRef as ReactComponent };